var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.918027 20.5H17.1982C17.705 20.5 18.1162 20.1019 18.1162 19.6107V15.0615H16.2803V18.7214L1.83605 18.7212V15.0615H0V19.6107C0 20.1019 0.411047 20.5 0.918027 20.5V20.5Z",
    fill: "#167092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45847 6.97259L8.14014 3.40483V16.0028H9.97604L9.97619 3.40483L13.6589 6.97274C13.8379 7.14648 14.0729 7.23314 14.3077 7.23314C14.5427 7.23314 14.7777 7.14648 14.957 6.97274C15.3152 6.62554 15.3152 6.06228 14.957 5.7151L9.05824 0L3.16022 5.7151C2.80201 6.06258 2.80201 6.62556 3.16052 6.97274C3.51843 7.32008 4.09993 7.31979 4.45857 6.97274L4.45847 6.97259Z",
    fill: "#167092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadActive);
export default __webpack_public_path__ + "static/media/upload-active.a8afc23ef4f60b15487d87c6845ea586.svg";
export { ForwardRef as ReactComponent };